// =====================================================
// CALCULATOR TRACKING — FINAL VERSION (FIXED PRICE LOGIC)
// =====================================================

// Listen to all relevant calculator interactions
document.addEventListener("change", trackCalculator);
document.addEventListener("input", trackCalculator);
document.addEventListener("click", trackCalculator);

function trackCalculator(e) {

  // =====================================================
  // STEP 0 — ONLY TRACK CALCULATOR ELEMENTS
  // =====================================================
  if (
    e.target.classList.contains("option-number-input") ||
    e.target.classList.contains("dropbtn") ||
    e.target.closest(".option-type-dropdown")
  ) {

    // Prevent rapid duplicate firing
    clearTimeout(window.calcTimeout);

    window.calcTimeout = setTimeout(function() {

      // =====================================================
      // STEP 1 — CALCULATE TOTAL WORD COUNT
      // =====================================================
      let inputs = document.querySelectorAll(".option-number-input");
      let total = 0;

      inputs.forEach(input => {
        let val = parseFloat(input.value);
        if (!isNaN(val)) total += val;
      });

      // =====================================================
      // STEP 2 — WAIT FOR PRICE TO UPDATE
      // =====================================================
      setTimeout(function() {

        let priceElement = document.querySelector(".addition-price-value");
        let price = 0;

        if (priceElement) {
          let priceText = priceElement.textContent || "";

          // Remove currency symbols and formatting
          priceText = priceText.replace(/[^\d.]/g, "").trim();

          price = parseFloat(priceText);
          if (isNaN(price)) price = 0;
        }

        // =====================================================
        // STEP 3 — DETECT REAL PRICE FORMAT (ROBUST NORMALISATION)
        // =====================================================
        let finalPrice = price;

        // Maximum possible real price based on your business logic
        let maxReal = total > 0 ? (total * 23.49 / 1000) : 500;

        // Allow margin
        let threshold = maxReal * 2;

        // Fix ×100 bug (value too large)
        if (finalPrice > threshold) {
          console.warn("SAFEGUARD FIX ×100:", finalPrice, "→", finalPrice / 100);
          finalPrice = finalPrice / 100;
        }

        // Fix ÷100 bug (value too small)
        if (finalPrice > 0 && finalPrice < (maxReal / 200)) {
          console.warn("SAFEGUARD FIX ÷100:", finalPrice, "→", finalPrice * 100);
          finalPrice = finalPrice * 100;
        }

        // Final validation
        if (finalPrice <= 0 || finalPrice > maxReal * 5) {
          console.error("SAFEGUARD BLOCK: invalid value", finalPrice);
          return;
        }

        // Debug price handling
        console.log("PRICE DEBUG:", {
          raw_price: price,
          final_price: finalPrice,
          max_expected: maxReal
        });

        // =====================================================
        // STEP 4 — GET CURRENCY FROM SHOPIFY
        // =====================================================
        let currency = "GBP";

        if (window.Shopify && Shopify.currency && Shopify.currency.active) {
          currency = Shopify.currency.active;
        } else if (window.Shopify && Shopify.shop_currency) {
          currency = Shopify.shop_currency;
        }

        if (!currency || currency.length !== 3) {
          currency = "GBP";
        }

        // Debug output
        console.log("DEBUG:", {
          word_count: total,
          raw_price: priceElement ? priceElement.textContent : "NOT FOUND",
          parsed_price: price,
          final_price: finalPrice,
          currency: currency
        });

        // =====================================================
        // STEP 5 — FIRE EVENT ONLY WHEN VALUE CHANGES
        // =====================================================
        if (total > 0 && finalPrice > 0) {

          if (window.lastTrackedPrice !== finalPrice) {

            // =====================================================
            // VALUE CALCULATION (TRACK 1% OF DISPLAYED PRICE)
            // =====================================================
            let calculatedValue = finalPrice * 0.01;

            let payload = {
              word_count: total,
              value: calculatedValue,
              currency: currency
            };

            // =====================================================
            // 1️⃣ GTM / GA4 TRACKING
            // =====================================================
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "calculator_result",
              ...payload
            });

            // =====================================================
            // 2️⃣ SHOPIFY PIXEL BRIDGE
            // =====================================================
            window.dispatchEvent(new CustomEvent("calculator_result", {
              detail: payload
            }));

            // =====================================================
            // 3️⃣ DIRECT SHOPIFY EVENT (FALLBACK)
            // =====================================================
            if (typeof analytics !== "undefined" && analytics.publish) {
              analytics.publish("calculator_result", payload);
            }

            // Debug success
            console.log("TRACKED SUCCESS:", payload);

            // Prevent duplicate tracking
            window.lastTrackedPrice = finalPrice;

          }

        }

      }, 1200);

    }, 600);

  }

}

// =====================================================
// END OF CALCULATOR TRACKING
// =====================================================